const CURRENT_TENANT_UUID_STORAGE_KEY = 'currentTenantUuid';
export const TENANT_CONTEXT_CHANGED_EVENT = 'zhiyue:tenant-context-changed';

const notifyTenantContextChanged = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(TENANT_CONTEXT_CHANGED_EVENT));
  }
};

export const saveCurrentTenantUuid = (tenantUuid?: string | null) => {
  const previousTenantUuid = readCurrentTenantUuid();
  const nextTenantUuid = tenantUuid || null;

  try {
    if (nextTenantUuid) {
      localStorage.setItem(CURRENT_TENANT_UUID_STORAGE_KEY, nextTenantUuid);
    } else {
      localStorage.removeItem(CURRENT_TENANT_UUID_STORAGE_KEY);
    }
  } catch {
    // ignore storage access errors
  }

  if (previousTenantUuid !== nextTenantUuid) {
    notifyTenantContextChanged();
  }
};

export const readCurrentTenantUuid = () => {
  try {
    return localStorage.getItem(CURRENT_TENANT_UUID_STORAGE_KEY);
  } catch {
    return null;
  }
};
